// extracted by mini-css-extract-plugin
export default {"box":"Legend_box__Vjgb-"};